import React from 'react'
import Loading from "../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const MobileMPOS = dynamic(() => import('../components/mPos/MobileMPOS'), {
  loading: () => <Loading />,

});
const DesktopMPOS = dynamic(() => import('../components/mPos/DesktopMPOS'), {
  loading: () => <Loading />,

});

const enterprise = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>QB mPOS - Use Your Android Mobile Like POS Billing Machine</title>
        <meta name='robots' content='noindex' />
        <meta property="og:title" content="QueueBuster mPOS - Use Your Android Mobile Like POS Billing Machine | Android POS Billing" />
        <meta property="og:description" content="Elevate your business with QueueBuster mPOS – harness the capabilities of an Android mobile as a POS billing machine. Experience efficiency and reliability for seamless Android POS billing." />
        {/* <meta property="og:url" content="https://queuebuster.co/enterprise-pos-solution" /> */}
      </Head>
      {
        mobileView ? <MobileMPOS /> : <DesktopMPOS />
      }
    </>
  )
}

export default enterprise